interface SidebarHeaderProps {
  children: React.ReactNode
}

export default function SidebarHeader({ children }: SidebarHeaderProps) {
  return (
    <div className="flex flex-col gap-y-4 py-4">
      {children}
    </div>
  )
} 